import { type WhiteboardAttributes } from './generated/WhiteboardAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import Fragment from '../Fragment';
import { isEmpty } from 'lodash';
import { DocumentTypeEnum } from '../Enums';

interface Whiteboard extends WhiteboardAttributes {}

@model
class Whiteboard extends ApplicationModel {
  // Start auto-generated
  static typename: 'Whiteboard' = 'Whiteboard';
  get typename(): 'Whiteboard' {
    return 'Whiteboard';
  }

  static internalTypename: 'Whiteboard' = 'Whiteboard';
  get internalTypename(): 'Whiteboard' {
    return 'Whiteboard';
  }

  static fields = {
    collaborativeVersion: attr({ readable: true }),
    documentExportTitle: attr({ readable: true }),
    editorContent: attr({ readable: true, json: true }),
    editorProperties: attr({ readable: true, json: true }),
    id: attr({ readable: true }),
    unresolvedCommentsCount: attr({ readable: true }),
    usedTemplateIds: attr({ readable: true }),
    versionsCount: attr({ readable: true }),
    defaultCardLayout: attr.belongsTo({
      readable: true,
      typename: 'CardLayout',
    }),
    page: attr.belongsTo({ readable: true, typename: 'Page' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
    version: attr.belongsTo({
      args: { id: 'ID!' },
      readable: true,
      typename: 'WhiteboardVersion',
    }),
    whiteboardable: attr.belongsTo({
      readable: true,
      typename: [
        'CustomFieldValue',
        'Note',
        'NoteTemplate',
        'Page',
        'Presentation',
        'Project',
        'Task',
        'Unimplemented',
      ],
    }),
    attachments: attr.hasMany({ readable: true }),
    authors: attr.hasMany({ readable: true }),
    versions: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  /**
   * Link the use of a template in this Whiteboard for display in the
   * Best Practices panel.
   * @param templateId The ID of the template to link.
   * @returns Whether the mutation was successful.
   */
  static async linkToTemplate(
    id: string,
    templateId: string
  ): Promise<Boolean> {
    const data = await ApplicationModel.mutate(
      new Fragment('linkTemplateToDocument')
        .argument('id', id)
        .argument('type', DocumentTypeEnum.WHITEBOARD, true)
        .argument('templateId', templateId)
        .argument('__reactivelyUpdate', true)
    );

    return isEmpty(data.linkTemplateToDocument.errors);
  }
}

export default Whiteboard;
